import LitElementBase from "./lit/element-base"
import GDPRToast from './gdpr-toast-dialog'

export default class GDPRModule extends LitElementBase {
    
    static get DomTag() { return  'gdpr-module'; }

    static get ACCEPT_CATEGORIES() {
		return {
            NECESSARY: "NECESSARY",
            PERFORMANCE: "PERFORMANCE",
            FUNCTIONAL: "FUNCTIONAL",
            TARGETING: "TARGETING"
		}
    }

    static get ACCEPT_TYPES() {
		return {
            PERFORMANCE: 4,
            FUNCTIONAL: 2,
            TARGETING: 1,
            NECESSARY: 0
		}
    }
    
    static get properties() {
		return {
            "site_name": {type: String},
            "scripts_url": {type: String},
            "cookie_policy_url": {type: String},
            "cookie_policy_md_url": {type: String},
            "privacy_policy_url": {type: String},
            "privacy_policy_md_url": {type: String}
        }
	}
	
	constructor() {
		super();
        this.AcceptLevel = localStorage.getItem("GDPRPreferences") || -1;
    }

    InjectScripts(scripts) {        
        localStorage.setItem("GDPRPreferences", this.AcceptLevel);

        let scriptsContainer = document.createElement('div');
        scriptsContainer.innerHTML = scripts;

        Object.keys(GDPRModule.ACCEPT_CATEGORIES).forEach((CATEGORY) => {
            if(this.AcceptLevel >= GDPRModule.ACCEPT_TYPES[CATEGORY]){
                scriptsContainer.querySelectorAll(`[cookie-type=${CATEGORY}]`).forEach((el) => {
                        switch(el.nodeName){
                            case "SCRIPT":
                                let newScript = document.createElement("script")
                                newScript.type = "text/javascript";
                                if(el.src){
                                    newScript.src = el.src;
                                }
                                else {
                                    newScript.textContent = el.textContent;
                                }
                                document.head.appendChild(newScript)
                            break;
                            case "NOSCRIPT":
                                let newNoscript = document.createElement("noscript")
                                newNoscript.innerHTML = el.innerHTML;
                                document.head.appendChild(newNoscript)
                            break;
                            default:
                                console.error(el.nodeName + " element type not managed")
                        }
                })
                this.AcceptLevel -= GDPRModule.ACCEPT_TYPES[CATEGORY];
            }
        })
    }

    render(){
        fetch(this.scripts_url)
            .then(res => {
                res.text().then(scripts => {
                    this.InjectScripts(scripts)
                })
            })
    }

    firstUpdated() {
        if(this.AcceptLevel != -1)
            return

        window.history.scrollRestoration = "manual"; ///BUG-1588
        const cookie_policy = {
            url: this.cookie_policy_md_url || this.cookie_policy_url,
            isMarkdown: this.cookie_policy_md_url != null
        }

        const privacy_policy = {
            url: this.privacy_policy_md_url || this.privacy_policy_url,
            isMarkdown: this.privacy_policy_md_url != null
        }

        let dlg = new GDPRToast(this.site_name, cookie_policy, privacy_policy)
        document.body.append(dlg)

        dlg.OnHide((res) => {
            setTimeout(() => { window.history.scrollRestoration = "auto" }, 100); ///BUG-1588
            if(res == true)
                if(dlg.Data && typeof dlg.Data.AcceptLevel != "undefined"){
                    this.AcceptLevel = dlg.Data.AcceptLevel
                    this.update();
                }
        })
    }
}

GDPRModule.RegisterElement()